import SVG from 'react-inlinesvg';
import ZoomInIcon from 'lib/assets/In.svg';
import ZoomOutIcon from 'lib/assets/Out.svg';
import SatelliteIcon from 'lib/assets/Satellite.svg';
import styled from 'styled-components';

import { useState, useEffect } from 'react';

interface Props {
  map?: google.maps.Map;
}

const Nav = ({ map }: Props) => {
  const [satelliteOn, setSatelliteOn] = useState(false);

  /* locate GM street view pegman in the DOM, move it into new GM nav*/
  useEffect(() => {
    const movePegman = setInterval(() => {
      const pegman = document.querySelector<HTMLElement>('.gm-svpc');
      const pegmanDiv = document.querySelector<HTMLElement>('#pegmanDiv');

      if (pegman && pegmanDiv) {
        if (!document.querySelector('#pegman')) {
          pegman.id = 'pegman';
          pegman.style.position = 'relative';
          pegman.style.borderRadius = '0';
          pegman.style.boxShadow = 'none';
          pegmanDiv.style.display = 'flex';
          pegmanDiv.style.flexDirection = 'column';
          pegmanDiv.style.alignItems = 'center';
          pegmanDiv.style.padding = '10px 0';
          pegman.setAttribute('data-cy', 'pegman');

          pegmanDiv.prepend(pegman);
        }
        clearInterval(movePegman);
      }
    }, 50);

    return () => {
      clearInterval(movePegman);
    };
  }, []);

  /* when in street view hide google nav bar */
  useEffect(() => {
    const hideGoogleNav = setInterval(() => {
      const googleNav = document.querySelector<HTMLElement>('#googleMapsNav');
      if (googleNav) {
        if (map?.getStreetView().getVisible()) {
          googleNav.style.display = 'none';
        } else {
          googleNav.style.display = 'flex';
        }
      }
    }, 1000);
    return () => {
      clearInterval(hideGoogleNav);
    };
  }, [map]);

  return (
    /* Custom zoom controls */
    <StyledNav data-cy="nav-bar" id="googleMapsNav">
      <NavButton
        onClick={() => {
          if (map) {
            map.setZoom(map.getZoom()! + 1);
          }
        }}
        data-cy="nav-button-zoom-in"
      >
        <SVG src={ZoomInIcon} />
      </NavButton>
      <NavDivider></NavDivider>
      <NavButton
        onClick={() => {
          if (map) {
            map.setZoom(map.getZoom()! - 1);
          }
        }}
        data-cy="nav-button-zoom-out"
      >
        <SVG src={ZoomOutIcon} />
      </NavButton>
      <NavDivider></NavDivider>
      <NavButton data-cy="nav-button-street-view">
        <div id="pegmanDiv">
          <NavText>
            STREET <br /> VIEW
          </NavText>
        </div>
      </NavButton>
      <NavDivider></NavDivider>
      {/* custom satellite view control */}
      <NavButton
        selected={satelliteOn}
        onClick={() => {
          const mapType = map?.getMapTypeId();
          setSatelliteOn(!satelliteOn);
          mapType === 'satellite'
            ? map?.setMapTypeId(google.maps.MapTypeId.ROADMAP)
            : map?.setMapTypeId(google.maps.MapTypeId.SATELLITE);
        }}
        data-cy="nav-button-satellite"
      >
        <SVG src={SatelliteIcon} />
        <NavText>
          SATELLITE <br /> VIEW
        </NavText>
      </NavButton>
    </StyledNav>
  );
};

export default Nav;

const StyledNav = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  width: 55px;
  height: 260px;
  bottom: 3vh;
  background-color: white;
  z-index: 100;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 1px 10px;
  border-radius: 10px;
  text-align: center;
  margin: 0 10px;
  overflow: hidden;
  cursor: pointer;
  left: ${({ theme }) => (theme.layout.sideMenuPosition === 'right' ? '0' : 'auto')};
  right: ${({ theme }) => (theme.layout.sideMenuPosition === 'left' ? '0' : 'auto')};
  .gm-svpc {
    top: 0 !important;
  }
  @media (max-width: 500px) and (max-height: 500px) {
    width: 47px;
    height: 180px;
  }
`;

const NavText = styled.p`
  font-size: 10px;
  padding: 0 0.3vh;
  color: black;
  margin: 0;
  @media (max-width: 500px) and (max-height: 500px) {
    font-size: 8px;
  }
`;

const NavButton = styled.button<{ selected?: boolean }>`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ selected }) => selected && 'background-color: #dfdfdf;'}
  svg {
    width: 40px;
  }
  @media (max-width: 500px) and (max-height: 500px) {
    svg {
      width: 29px;
    }
    #pegmanDiv {
      padding: 0 !important;
    }
  }
`;

const NavDivider = styled.div`
  border-bottom: 0.3vh solid lightgrey;
`;
